import React from 'react';
import { ForgotPassword } from './container';

export const ForgotPasswordScreen = () => {
    return <ForgotPassword />;
};
